import { TextField, styled } from '@mui/material';

/**
 * Editor
 */
export const SupplierInfoText = styled(TextField)(({ theme }) => ({
  '&& .MuiInputBase-root': {
    backgroundColor: theme.palette.paper.dark,
  },
}));
